/** Text stays literal; translation keys are resolved only by the rendering View. */
export type FilterWords =
    | { text: string }
    | { key: string; values?: Readonly<Record<string, string | undefined>> };

export const FILTERS_COPY = 'products.components.productTable.filters';

export const resolveFilterWords = (
    words: FilterWords,
    translate: (
        key: string,
        values?: Readonly<Record<string, string | undefined>>,
    ) => string,
): string =>
    'text' in words ? words.text : translate(words.key, words.values);

/** A compact enumeration, preserving the tags' punctuation in each locale. */
export const joinFilterValues = (
    values: readonly string[],
    language: string = 'en',
): string =>
    new Intl.ListFormat(language, { style: 'short', type: 'unit' }).format(
        values,
    );
